import React from 'react'
import { Grid, Button, Message, Breadcrumb, Card, Icon, Loader, Image } from 'semantic-ui-react';
import { Form } from 'formsy-semantic-ui-react';
import { dispatch } from '@rematch/core';
import ContributorsModal from '../../drive/modals/ContributorsModal'
import EditContributorRole from '../../drive/modals/EditContributorRole'
import LoadingComponent from "../../../../common/LoadingComponent";
import 'react-quill/dist/quill.snow.css'; // ES6
import _ from 'lodash';
import { toastr } from 'react-redux-toastr';
import EllipsisTooltip from '../../../../common/EllipsisTooltip';
import TextEditor from '../../../../common/TextEditor';
import { withRouter } from 'react-router-dom';
import { singleLineText } from '../../../../common/RegexValidation';
import ImageResizer from './../../../../drive/ImageResizer/ImageResizer';
import defaultImage from './../../../../../images/common/practice-default.png'
import ImageAvater from '../../../../drive/Components/ImageAvater';
import Labels from '../../../../common/Labels';
import wordImage from './../../../../../images/svg/Export/word.svg'


let baseCategory;
let category;
let subCategory;
let team;

class CreatePack extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            editUserDetails: {},
            otherSubCategory: '',
            hideButton: false,
            showInputIcon: false,
            knowledgeBankFlag: false,
            categoryFlag: false,
            subCategoryFlag: false,
            description: '',
            prerequisite: '',
            invitationError: null,
            categoryMsgFlag: false,
            open: false,
            updatedImage: defaultImage,
            images: [],
            categoryId:'',
            baseCategoryId:''
        }
        this.cancelAddOrg = this.cancelAddOrg.bind(this);
        this.deleteParticipate = this.deleteParticipate.bind(this);
        this.editContibutorRole = this.editContibutorRole.bind(this)
        this.handleChangebaseCategory = this.handleChangebaseCategory.bind(this);
        this.handleChangeCategory = this.handleChangeCategory.bind(this);
        this.handleChangeSubCategory = this.handleChangeSubCategory.bind(this);
        this.setsubCategory = this.setsubCategory.bind(this);
        this.updateText = this.updateText.bind(this);
        this.setDefaultImage = this.setDefaultImage.bind(this)
        this.handleChangeTeam = this.handleChangeTeam.bind(this);
    }
    openImageModal = (open) => {
        this.setState({ open: open })
    }

    cloudinaryImage = (imageData) => {
        this.setState({ loader: true })
        if (imageData && imageData.data) {
            this.setState({ updatedImage: imageData.data.secure_url, loader: false })
        }
    }

    handleChangebaseCategory(data, isLibraryChanged) {
        dispatch.lifeCycle.setCategoryAsync([]);
        dispatch.lifeCycle.setSubCategoryAsync([]);
        category = null;
        subCategory = null;
        team = null;
        this.setState({ baseCategoryId: data.target.value })
        if (data.target.value !== 'Select') {
            let baseCategoryId = data.target.value;
            if (this.props.scope === 'Private') {
                for (let i = 0; i < this.props.baseCategoriesArr.length; i++) {
                    let categoryData = this.props.baseCategoriesArr[i];
                    if (baseCategoryId.toString() === categoryData._id.toString()) {
                        baseCategory = categoryData;
                        break;
                    }
                }
            }
            else {
                for (let i = 0; i < this.props.publicCategoryList.length; i++) {
                    let categoryData = this.props.publicCategoryList[i];
                    if (baseCategoryId.toString() === categoryData._id.toString()) {
                        baseCategory = categoryData;
                        break;
                    }
                }
            }

            if (baseCategory) {
                if (baseCategory.nodes.length === 0) {
                    this.setState({ categoryMsgFlag: true })
                }
                else {
                    this.setState({ categoryMsgFlag: false })
                    dispatch.lifeCycle.setCategoryAsync(baseCategory.nodes);
                }
            }
            this.setState({ knowledgeBankFlag: false })
        }
        else {
            this.setState({ categoryMsgFlag: false })
            dispatch.lifeCycle.setCategoryAsync([]);
            baseCategory = null;
            category = null
            if (!isLibraryChanged) {
                this.setState({ knowledgeBankFlag: true ,baseCategoryId:""})
            }

        }
    }
    handleChangeCategory(data) {
        dispatch.lifeCycle.setSubCategoryAsync([]);
        if (data.target.value !== 'Select') {
        this.setState({ categoryId: data.target.value })
            let categoryId = data.target.value;
            for (let i = 0; i < this.props.categoriesArr.length; i++) {
                let categoryData = this.props.categoriesArr[i];
                if (categoryId.toString() === categoryData._id.toString()) {
                    category = categoryData;
                    break;
                }
            }
            if (category) {
                dispatch.lifeCycle.setSubCategoryAsync(category.nodes);
            }
            this.setState({ categoryFlag: false })
        }
        else {
            dispatch.lifeCycle.setSubCategoryAsync([]);
            category = null
            this.setState({ categoryFlag: true ,categoryId:""})
        }
        this.setState({ otherSubCategory: null })
    }
    handleChangeTeam(data) {
        if (data.target.value !== 'Select') {
            let teamId = data.target.value;
            for (let i = 0; i < this.props.teamList.length; i++) {
                let teamData = this.props.teamList[i];
                if (teamId.toString() === teamData._id.toString()) {
                    team = teamData;
                    break;
                }
            }
        } else {
            team = null
        }
    }
    handleChangeSubCategory(data) {
        if(data.target.value !== "Select Sub Category"){
            this.setState({subCategoryFlag:false})   
        }else{
            this.setState({ subCategoryFlag: true })
        }
        subCategory = data.target.value;
        this.setState({ otherSubCategory: data.target.value })
    }

    setsubCategory() {
        dispatch.lifeCycle.setSubCategoryAsync(category.subCategories);
        this.setState({ otherSubCategory: null })
    }

    editContibutorRole(e, user) {
        dispatch.lifeCycle.modalRoleChangeOpen(true);
        this.setState({ editUserDetails: user })
    }

    handleChange = (e, { value }) => {
        category = null;
        subCategory = null;
        team = null;
        this.handleChangebaseCategory({ target: { value: "Select" } }, true)
        dispatch.lifeCycle.setSubCategoryAsync([]);
        dispatch.lifeCycle.setCategoryAsync([]);
        this.setState({ value });
        dispatch.lifeCycle.setScopeAsync(value);
    }
    /* This is called on cancel button of life cycle form */
    cancelAddOrg(e) {
        e.preventDefault();
        const history = this.props.history;
        history.push({
            pathname: `/app/${this.props.match.params.accountId}/_ws/${this.props.match.params.workspaceId}/_pb`,
            state: { onClick: "CANCEL" }
        });
    }
    setDefault(bcArr) {
        if (!bcArr || bcArr.length === 0) return;
        const f1 = bcArr.find(f => f.default);
        if (!f1) return;
        baseCategory = f1;
        this.setState({ baseCategoryId: f1._id });
        dispatch.lifeCycle.setCategoryAsync(f1.nodes);

        const f2 = f1.nodes && f1.nodes.find(f => f.default);
        if (!f2) return;
        category = f2;
        this.setState({ categoryId: f2._id });
        dispatch.lifeCycle.setSubCategoryAsync(f2.nodes);

        const f3 = f2.nodes && f2.nodes.find(f => f.default);
        if (!f3) return;
        subCategory = f3._id;
        this.setState({ otherSubCategory: f3._id });
    }

    componentWillMount() {
        dispatch.app.setRouteParams(this.props.match.params)
        dispatch.lifeCycle.activePage('createPlaybook');
        dispatch.lifeCycle.setError(null);
        dispatch.lifeCycle.setCategoryAsync();
        dispatch.lifeCycle.setSubCategoryAsync();
        dispatch.lifeCycle.setScopeAsync('Private');
        dispatch.lifeCycle.modalOpen(false);
        dispatch.lifeCycle.setParticipantsAsync([]);
        dispatch.lifeCycle.setInvitedParticipantAsync([]);
        dispatch.lifeCycle.modalRoleChangeOpen(false);
        dispatch.lifeCycle.isPracticeAvailable(false)
        baseCategory = null;
        category = null;
        subCategory = null;
        team = null;

        dispatch.lifeCycle.displaySecondMenu(null);
        dispatch.createPack.showDuplicateIcon(false);
    }

    componentDidMount() {
        this.handleChangeTileImage()
        this.setDefault(this.props.baseCategoriesArr)
    }

    handleChangeTileImage = () => {
        let randomImageNumber = Math.floor(Math.random() * 10) + 1
        let imgUrl = "https://res.cloudinary.com/" + this.props.envData.cloudName + "/image/upload/Cards/playbook/" + randomImageNumber + ".png";
        this.setState({ updatedImage: imgUrl })
    }

    componentWillReceiveProps(newProps) {
        if (this.props.participantsData.length === 0)
            this.setAuthorData();
        if (newProps.baseCategoriesArr !== this.props.baseCategoriesArr) {
            this.setDefault(newProps.baseCategoriesArr);
        }
    }

    setAuthorData() {
        let createdAuthor = {
            accountUserId: this.props.user._id,
            role: 'author',
            name: this.props.user.firstName + " " + this.props.user.lastName,
            firstName: this.props.user.firstName,
            lastName: this.props.user.lastName,
            imageUrl: this.props.user.profilePic,
            profilePic: this.props.user.profilePic,
            email: this.props.user.email
        };
        let temp = this.props.participantsData.filter((participant) => { return participant.accountUserId === this.props.user._id });
        if (temp.length === 0) {
            this.props.participantsData.push(createdAuthor);
        }
    }
    deleteParticipate(event, user) {
        let message = <div className="confirmMessage">
            <h3>Remove User</h3>
            <label>{user.name}</label>
            <p>Are you sure to remove this User?</p>
            <span >This action is not reversible</span>
        </div>
        toastr.confirm(message, {
            onOk: () => {
                let temp = this.props.participantsData.filter((participant) => { return participant.accountUserId === user.accountUserId });
                dispatch.lifeCycle.setDeleteParticipantsAsync(_.indexOf(this.props.participantsData, temp[0]));
            }
        });
    }
    deleteInvitedUser(event, invite) {
        let message = <div className="confirmMessage">
            <h3>Remove Invitation</h3>
            <label>{invite.firstName}</label>
            <p>Are you sure to remove this invitation?</p>
            <span >This action is not reversible</span>
        </div>
        toastr.confirm(message, {
            onOk: () => {
                let temp = this.props.invitedUsersArray.filter((payload) => { return payload.email === invite.email });
                dispatch.lifeCycle.setDeleteInviteUserAsync(_.indexOf(this.props.invitedUsersArray, temp[0]));
            }
        });
    }

    async onSubmitCreatePack(formData) {
        if (this.props.loaderStatus || this.state.hideButton || this.props.validPracticeName || (!this.props.selectedAccount.publicAccess && this.props.scope === 'Public')) {
            return true;
        }
        if (!baseCategory || baseCategory === null) {
            this.setState({ knowledgeBankFlag: true })
        }
        else if (!category || category === null) {
            this.setState({ categoryFlag: true })
        }
        else if (baseCategory && category && !subCategory && !formData.subCategory || subCategory==="Select Sub Category") {
            this.setState({ subCategoryFlag: true })
        }
        else {
            this.setState({ hideButton: true })
            formData.organizationId = this.props.match.params.workspaceId;
            formData.accountId = this.props.match.params.accountId;
            formData.name = formData.name.trim();
            formData.description = this.state.description;
            formData.prerequisite = this.state.prerequisite;
            formData.slug = formData.name;
            formData.scope = this.props.scope;
            formData.baseCategory = baseCategory._id;
            formData.category = category._id;
            if(team) {
                formData.teamId = team._id;
            }
            if (!formData.subCategory) {
                formData.subCategory = subCategory;
            }
            formData.status = 0;
            formData.totalIntances = 0;
            formData.active = true;
            formData.lastUpdatedBy = this.props.user._id;
            formData.accountUserId = this.props.user._id;
            formData.participants = this.props.participantsData;
            formData.inviteArray = this.props.invitedUsersArray;
            formData.String = 'addParticipantsToOrganization';
            formData.organizationName = this.props.selectedOrganisation.name;
            formData.picture = this.state.updatedImage;
            if (this.state.template) {
                formData.templateDocx = this.state.template;
                formData.templateName = this.state.fileName
            }
            try {
                await dispatch.lifeCycle.addNewPracticeAsync(formData);
                dispatch.lifeCycle.getPacksAsync({ organizationId: this.props.selectedOrganisation.id, user: this.props.user, role: this.props.selectedOrganisation.role });
                formData = {};
            }
            catch (err) {
                this.setState({ "invitationError": err })
            }
        }
    }
    handleOpen = () => {
        dispatch.lifeCycle.modalOpen(true);

    }
    handlePlaybookNameChange = (event) => {
        let payload = {
            name: event.target.value.trim(),
            organisationId: this.props.selectedOrganisation.id
        }
        dispatch.lifeCycle.searchPracticeByName(payload);
    }

    handlePlaybookNameChangeFlag = (event) => {
        const inputValue = event.target.value;
        this.setState({ name: inputValue });
        if (this.props.validPracticeName && inputValue.trim() === this.state.name.trim()) {
          dispatch.lifeCycle.isPracticeAvailable(true);
        } else {
          dispatch.lifeCycle.isPracticeAvailable(false);
        }
      }
    handleChangeDescription = (value) => {
        this.setState({ description: value })
    }
    handleChangePrerequisite = (value) => {
        this.setState({ prerequisite: value })
    }

    updateText(data, name) {
        if (name === "Description") {
            this.setState({ description: data })
        } else if (name === "Prerequisite") {
            this.setState({ prerequisite: data })
        }
    }
    setDefaultImage() {
        let data = {
            secure_url: null
        }
        dispatch.lifeCycle.setCardImageAsync(data);
    }
    fileUploaded = (data) => {
        data.preventDefault()
        if (data.target.files[0].name.split('.').pop() === 'docx') {

            var fileToLoad = data.target.files[0];
            var fileReader = new FileReader();

            fileReader.onload = async (fileLoadedEvent) => {
                if (fileLoadedEvent.target.result) {
                    this.setState({ template: fileLoadedEvent.target.result, fileName: fileToLoad.name })
                    // await dispatch.lifeCycle.uploadPlaybookTemplate({ data: fileLoadedEvent.target.result, organizationId: selectedPracticeLibrary.organizationId, accountId: selectedPracticeLibrary.accountId, packId: selectedPracticeLibrary._id, fileName: fileToLoad.name });
                    //   this.stopLoader();
                } else {
                    toastr.error('Message', 'Invalid File.');
                    // this.stopLoader();
                }
            };

            fileReader.readAsArrayBuffer(fileToLoad, "UTF-8");
            data.target.value = null;
        } else {
            toastr.error('Message', 'Invalid File.');
        }
    }
    downloadTemplate = async () => {

        await dispatch.lifeCycle.getPlaybookTemplate("none");
    }
    reset = () => {
        this.setState({ template: null, fileName: null });
    }
    render() {
        let intList = this.props.selectedAccount && this.props.selectedAccount.integrations && this.props.selectedAccount.integrations.length !== 0 && this.props.selectedAccount.integrations.filter(
            (item) => item.isActive
        );
        const errorLabel = <div className="customErrorLabelforPlaybook" >abcd</div>;
        const { loading } = this.props;
        let breadCrumb = <Breadcrumb className="breadCrumbs" >
            <Breadcrumb.Section><span className="primary">Create Playbook</span></Breadcrumb.Section>
        </Breadcrumb>

        var collator = new Intl.Collator(undefined, {
            numeric: true,
            sensitivity: 'base'
        });
        let bcA
        if (this.props.scope === "Private") {
            bcA = this.props.baseCategoriesArr && this.props.baseCategoriesArr.length !== 0 ?
                this.props.baseCategoriesArr.sort((a, b) => {
                    return collator.compare(a.name, b.name)
                }) : null
        }
        else {
            bcA = this.props.publicCategoryList && this.props.publicCategoryList.length !== 0 ?
                this.props.publicCategoryList.sort((a, b) => {
                    return collator.compare(a.name, b.name)
                }) : null
        }

        let cA = this.props.categoriesArr && this.props.categoriesArr.length !== 0 ?
            this.props.categoriesArr.sort((a, b) => {
                return collator.compare(a.name, b.name)
            }) : null

        let scA = this.props.subCategoriesArr && this.props.subCategoriesArr.length !== 0 ?
            this.props.subCategoriesArr.sort((a, b) => {
                return collator.compare(a.name, b.name)
            }) : null

        return (
            <div className="pad_20 overflow-auto h_100">
                {breadCrumb}
                <LoadingComponent active={loading} message="loading..." />
                <Form noValidate
                    ref={ref => this.form = ref}
                    className="formcyForm"
                    name="cretePack"
                    id="cretePackID"
                    onValidSubmit={(event) => { this.onSubmitCreatePack(event) }}
                >
                    <Grid>
                        <Grid.Row className="createPack">
                            <Grid.Column width={11}>

                                <Grid.Row className="pad_0">
                                    <Grid.Column width={16}>
                                        <Form.Field>
                                            <Form.Input
                                                required
                                                name="name"
                                                id="name"
                                                label="Name"
                                                autoComplete="off"
                                                value={this.state.name}
                                                onBlur={this.handlePlaybookNameChange}
                                                onChange={this.handlePlaybookNameChangeFlag}
                                                validations={{ matchRegexp: singleLineText }}
                                                errorLabel={errorLabel}
                                                validationErrors={{
                                                    matchRegexp: 'Max limit is 128. No space allowed in starting.',
                                                    isDefaultRequiredValue: 'Name is required',
                                                }}
                                                instantValidation
                                                autoFocus
                                            />

                                            {this.props.validPracticeName && this.state.name ?
                                                <span className="clr-red">Playbook with same name already exists. Please rename the playbook.</span>
                                                : ''}

                                        </Form.Field>
                                    </Grid.Column>
                                </Grid.Row>
                                <Grid.Row className="pad_0">
                                    <Grid.Column width={8} className="float-left">
                                        <Form.Group>
                                            <Form.Input
                                                name="version"
                                                id="version"
                                                label="Version"
                                                required
                                                value='1.0.0'
                                                validations={{ matchRegexp: new RegExp(/^(([0-9]+\.[0-9]+(\.[0-9]+)?))$/) }}
                                                errorLabel={errorLabel}
                                                validationErrors={{
                                                    matchRegexp: 'No word or special characters allowed',
                                                    isDefaultRequiredValue: 'Version is required',
                                                }}
                                                instantValidation
                                                disabled
                                            />
                                        </Form.Group>
                                    </Grid.Column>

                                </Grid.Row>

                            </Grid.Column>

                            <Grid.Column width={5}>
                                <label>Card Image</label>
                                <div style={{ "paddingTop": "5px" }}>
                                    <Card className="organizationCard" >
                                        <Card.Content >
                                            <div >
                                                <Loader active={this.state.loader} />
                                                <img src={this.state.updatedImage} className="fitImage" alt="Playbook Image" />
                                                <Button type="button" className="circular_24_icon second-rectangle-image" icon='refresh' onClick={this.handleChangeTileImage} />
                                                <Button type="button" className="circular_24_icon first-rectangle-image" icon='pencil' onClick={() => this.openImageModal(true)} />
                                            </div >
                                        </Card.Content>
                                    </Card>
                                    <ImageResizer
                                        image={this.state.updatedImage}
                                        openImageModal={this.openImageModal}
                                        cloudinaryImage={this.cloudinaryImage}
                                        open={this.state.open}
                                        envData={this.props.envData}
                                        width={504}
                                        height={280}
                                    />
                                </div>
                            </Grid.Column>
                        </Grid.Row>
                        <Grid.Row className="createPack">
                            <Grid.Column width={16} >
                                <TextEditor
                                    name="Description"
                                    text={this.state.description}
                                    type="textarea"
                                    onChangeText={this.updateText}
                                    id='practiceDescription'
                                />
                            </Grid.Column>
                            <Grid.Column width={16}>
                                <TextEditor
                                    name="Prerequisite"
                                    text={this.state.prerequisite}
                                    type="textarea"
                                    onChangeText={this.updateText}
                                    id='practicePrerequisite'
                                />
                            </Grid.Column>
                        </Grid.Row>
                        <Grid.Row className="createPack">
                            {/* <label ><strong>Publishing / Category</strong></label> */}
                            <Grid.Column width={16}>
                                <label className='required-field f_11'>Publish Level </label>
                                <Form.Group grouped style={{ "marginLeft": "20px" }}>

                                    {(this.props.selectedOrganisation.publicLibraryAccess && this.props.selectedAccount.publicAccess && this.props.selectedOrganisation.role === 'workspaceOwner') ?
                                        <Form.Field style={{ "marginTop": "12px" }}>

                                            <b><Form.Radio
                                                name='scope'
                                                label='Workspace Library'
                                                value='Private'
                                                checked={this.props.scope === 'Private'}
                                                onChange={this.handleChange}
                                                style={{ "marginRight": "20px" }}
                                            /></b>
                                            <div style={{ margin: '0px 0 10px 22px' }}>Playbook will appear under Workspace Library after it is published. All workspace level users can view this playbook.</div>

                                            <div>
                                                <b>
                                                    <Form.Radio
                                                        name='scope'
                                                        label='Public Library'
                                                        value='Public'
                                                        checked={this.props.scope === 'Public'}
                                                        onChange={this.handleChange}
                                                    />
                                                </b>
                                                <div style={{ margin: '0px 0 10px 22px' }}>Playbook will appear under Public Library after it is published. All platform users can view this playbook.</div>
                                            </div>

                                        </Form.Field> :
                                        <div style={{ display: 'block' }}>
                                            <h3 style={{ margin: "10px 0 0px 22px" }}>
                                                Workspace Library
                                            </h3>
                                            <div style={{ margin: '0px 0 10px 22px' }}>Playbook will appear under Workspace Library after it is published. All workspace level users can view this playbook.</div>
                                        </div>

                                    }

                                </Form.Group>
                            </Grid.Column>
                            <Grid.Column width={16} style={{ margin: "10px 0 5px 0" }}>
                                <label className=' f_11'>Publish Category </label>
                            </Grid.Column>
                            <Grid.Column width={5}>

                                <Form.Group grouped style={{ "marginLeft": "20px" }}>
                                    <Form.Field label='Knowledge Bank'
                                        id='KnowledgeBank' required control='select'
                                        errorLabel={errorLabel}
                                        validationErrors={{
                                            isDefaultRequiredValue: 'Knowledge Bank is required',
                                        }}
                                        value={this.state.baseCategoryId}
                                        onChange={this.handleChangebaseCategory}
                                        className="formcyFormErrorMsg">
                                        <option value="Select">Select</option>
                                        {bcA && bcA.map((baseCategory, index) => {
                                            return (
                                                <option key={index} value={baseCategory._id} >{baseCategory.name}</option>
                                            );
                                        }, this)}

                                    </Form.Field>
                                    {this.state.knowledgeBankFlag ?
                                        <span style={{ "color": "red", fontSize: '0.8rem', margin: '0 0 0em' }}>Knowledge Bank is required.</span> : ''}
                                </Form.Group>
                            </Grid.Column>
                            <Grid.Column width={1}>
                                <Icon name='angle right' color='grey' size="large" style={{ "paddingTop": "30px" }} />
                            </Grid.Column>
                            <Grid.Column width={5}>
                                <Form.Field label='Category'
                                    id='Category' required control='select'
                                    errorLabel={errorLabel}
                                    validationErrors={{
                                        isDefaultRequiredValue: 'Category is required',
                                    }}
                                    value={this.state.categoryId}
                                    onChange={this.handleChangeCategory}
                                    disabled={!this.state.baseCategoryId ||this.props.baseCategoriesArr.length<0}
                                    className="formcyFormErrorMsg">
                                    <option>Select</option>
                                    {cA && cA.map((categories, index) => {
                                        return (
                                            <option key={index} value={categories._id}>{categories.name}</option>
                                        );
                                    }, this)}
                                </Form.Field>
                                {this.state.categoryFlag ?
                                    <span style={{ "color": "red", fontSize: '0.8rem', margin: '0 0 0em' }}>Category is required.</span> : ''}
                            </Grid.Column>
                            <Grid.Column width={1}>
                                <Icon name='angle right' color='grey' size="large" style={{ "paddingTop": "30px" }} />
                            </Grid.Column>
                            <Grid.Column width={4}>
                                {((this.props.subCategoriesArr.length >= 0) && this.state.otherSubCategory !== 'others') || this.props.scope !== "Private" ?
                                    <div>
                                        <Form.Field label='Sub Category'
                                            id='Subcategory' required control='select'
                                            errorLabel={errorLabel}
                                            validationErrors={{
                                                isDefaultRequiredValue: 'Sub Category is required',
                                            }}
                                            value={this.state.otherSubCategory}
                                            onChange={this.handleChangeSubCategory}
                                            disabled={!this.state.categoryId||this.props.subCategoriesArr.length<0||!this.state.baseCategoryId}>  
                                            <option>Select Sub Category</option>
                                            {scA && scA.filter((f, i) => { return f.name !== "Others" }).map((categories, index) => {
                                                return (
                                                    <option key={index} value={categories._id}>{categories.name}</option>
                                                );
                                            }, this)}
                                            {this.props.scope === "Private" && <option value="others">Others</option>}
                                        </Form.Field>
                                        {this.state.subCategoryFlag ?
                                            <span style={{ "color": "red" }}>Sub Category is required.</span> : ''}
                                    </div> :
                                    <div>
                                        {this.props.subCategoriesArr.length >= 0 && <Icon name='delete' onClick={this.setsubCategory} className="subcategoryOthers" />}
                                        <Form.Input
                                            required
                                            name="subCategory"
                                            id="Subcategory"
                                            label="Sub Category"
                                            validations="isWords"
                                            validations={{ matchRegexp: singleLineText }}
                                            errorLabel={errorLabel}
                                            validationErrors={{
                                                matchRegexp: 'Max limit is 128. No space allowed in starting.',
                                                isDefaultRequiredValue: 'Sub Category is required',
                                            }}
                                            instantValidation
                                        />

                                    </div>
                                }

                            </Grid.Column>
                            {this.state.categoryMsgFlag ?
                                <Grid.Column width={16}>
                                    <span className="clr-red">Categories not available in selected knowledge bank. Please select another knowledge bank or contact your account owner.</span>
                                </Grid.Column> : ''}
                        </Grid.Row>



                        <Grid.Row className="createPack">
                            <Grid.Column width={16}>
                                <strong style={{ padding: "0px 0 20px 0", display: "block" }} >
                                    Add Participants
                                    <Button icon='plus'
                                        type="button"
                                        color='green'
                                        onClick={this.handleOpen}
                                        className="bg-none clr-green"
                                        style={{ 'cursor': 'pointer' }} />
                                </strong>
                            </Grid.Column>

                            <Grid.Column width={16}>
                                <Card.Group>
                                    {this.props.participantsData && this.props.participantsData.length ?
                                        this.props.participantsData.map(function (participant, index) {
                                            return (
                                                <Card className="contributorCard" style={{ "cursor": 'pointer' }} key={index} >
                                                    <Card.Content onClick={(e) => this.editContibutorRole(e, participant)}>
                                                        <ImageAvater user={participant} className="h_32 w_32" profilePic={participant.imageUrl} />
                                                        <Card.Header>
                                                            <EllipsisTooltip
                                                                name={participant.name}
                                                                line={2} />
                                                        </Card.Header>
                                                        <Card.Meta className="f_10">{participant.role === "author" ? "Designer" : participant.role}</Card.Meta>
                                                    </Card.Content>
                                                    {participant.accountUserId !== this.props.user._id ?
                                                        <Icon className="trashImage trash-color" floated='right' onClick={(event) => this.deleteParticipate(event, participant)} name="trash alternate" style={{ "cursor": "pointer" }} />
                                                        : ''}
                                                </Card>
                                            );
                                        }, this)
                                        : ''}


                                    {this.props.invitedUsersArray && this.props.invitedUsersArray.length ?
                                        this.props.invitedUsersArray.map(function (invite, index) {
                                            return (
                                                <Card className="contributorCard playbookInviteBg" style={{ "cursor": 'pointer' }} key={index} >
                                                    <Card.Content>
                                                        <ImageAvater user={invite} className="h_32 w_32" />
                                                        <Card.Header>{invite.firstName + ' ' + invite.lastName}</Card.Header>
                                                        <Card.Meta className="f_10">{invite.role + " (Invited)"}</Card.Meta>
                                                    </Card.Content>
                                                    <Icon className="trashImage trash-color" floated='right' onClick={(event) => this.deleteInvitedUser(event, invite)} name="trash alternate" style={{ "cursor": "pointer" }} />
                                                </Card>
                                            );
                                        }, this)
                                        : ''}

                                </Card.Group>


                            </Grid.Column>
                        </Grid.Row>
                        {this.props.teamList && this.props.teamList.length>0 && <Grid.Row className="createPack">
                        <Grid.Column width={16} style={{ margin: "5px 0 5px 5px" }}>
                                <label className=' f_11'>Select Team</label>
                            </Grid.Column>
                            <Grid.Column width={5} style={{ marginLeft: "20px" }}>
                                {this.props.teamList && this.props.teamList.length>0 && <Form.Field 
                                id='TeamList' control='select'
                                onChange={this.handleChangeTeam}
                                className="formcyFormErrorMsg">
                                    <option>Select</option>
                                    {this.props.teamList && this.props.teamList.map((team, index) => {
                                        return (
                                            <option key={index} value={team._id}>{team.name}</option>
                                        );
                                    }, this)}
                                </Form.Field>
                                }
                            </Grid.Column>
                        </Grid.Row>}
                        <Grid.Row className="createPack">
                            <Grid.Column width={16}>
                                <Labels
                                    text={<span>Export Setting <span onClick={this.reset} className={`float-right ${this.state.template ? "clr-blue cursor-pointer" : ''}`}>Reset</span></span>} />
                                <Labels
                                    text={<span>
                                        <span >
                                            <Image
                                                style={{
                                                    height: "16px",
                                                    margin: "0 5px 0 0", float: "left"
                                                }}
                                                src={wordImage} /></span>Word Document
                                    </span>}
                                />
                                <Labels
                                    name="Current Template"
                                    text={this.state.template ? <EllipsisTooltip name={this.state.fileName} /> : " Default"} />
                            </Grid.Column>
                            <Grid.Column width={16}>
                                <div className="float-left" >
                                    <span
                                        className="clr-blue cursor-pointer"
                                        onClick={this.downloadTemplate}
                                    >Download Default Template</span>
                                </div>
                                <div className="float-right" >
                                    <span className="clr-blue" style={{
                                        width: "150px",
                                        display: "inline-block",
                                        verticalAlign: "bottom",
                                        textAlign: "right",
                                        margin: "0 5px"
                                    }}>Need help in creating a word template ?</span>&nbsp;
                                    <div className="file-upload-button-wrap float-right">
                                        <label className="file-upload-button button-info" for="upload" >
                                            <Icon name='upload' /> Upload</label>
                                        <input id="upload" type="file" onChange={(e) => this.fileUploaded(e)} accept=".docx" />
                                    </div>
                                </div>
                            </Grid.Column>
                        </Grid.Row>

                        {/* //integrations row  */}
                        {this.props.selectedAccount && this.props.selectedAccount.integrations ? 
                        <Grid.Row className="createPack">
                            <Grid.Column width={16}>
                            <Labels
                                    text={<span><h3 style={{ display:"inline-block" , "marginRight": "7px" }}>Integration Support : </h3></span> } 
                            />
                            
                                { 
                                    (intList && intList.length>0) ? intList.map(integration=>{
                                        
                                        return  (
                                            <Labels
                                                text={
                                                <span>
                                                <span >
                                                    <Image
                                                        style={{
                                                        height: "16px",
                                                        margin: "0 5px 0 0", 
                                                        float: "left"
                                                    
                                                    } }
                                                src={integration.id.image} /></span>{integration.id.label}
                                                </span>}
                                            />
                                        )
                                    }) : <div>No integrations configured currently.</div>
                                }
                            

                            </Grid.Column>
                        </Grid.Row> : null}
                        
                        {this.state.invitationError && this.state.invitationError.code === 409 ?
                            <Message color='yellow' className="inviteWarning"
                                style={{ "display": "block" }}
                                content="Playbook with same name already exists. Please rename the playbook."
                            /> : this.state.invitationError && this.state.invitationError.message ?
                                <Message color='yellow' className="inviteWarning"
                                    style={{ "display": "block" }}
                                    content={this.state.invitationError.message}
                                /> : ''
                        }
                        {/* <Grid.Row>
                            <Grid.Column width={5}><span onClick={this.downloadTemplate}>Download default Template</span></Grid.Column>
                            <Grid.Column width={2}></Grid.Column>
                            <Grid.Column width={5}>Need help in creating a word template?</Grid.Column>
                            <Grid.Column width={3}>
                                <div>
                                    <label>
                                        <Icon name='cloud upload' className={`f_16 `} style={{ verticalAlign: "top", margin: "-2px 0 0 0" }} />Upload
                                        <input type="file" name="file1" id="file1" className="inputfile" onChange={(e) => this.fileUploaded(e)} accept=".docx" />
                                    </label>
                                </div>
                            </Grid.Column>
                        </Grid.Row> */}
                        <Grid.Row>
                            <Grid.Column width={16} className="actionInFormcy border-none" >
                                <Button disabled={this.props.loaderStatus || this.state.hideButton || this.props.validPracticeName || (!this.props.selectedAccount.publicAccess && this.props.scope === 'Public')} floated='right' id="savebtn" className="button-submit" type="submit">Create & Configure</Button>
                                <Button floated='right' className="button-cancel" id="cancelbtn" onClick={this.cancelAddOrg}>Cancel</Button>
                            </Grid.Column>
                        </Grid.Row>
                    </Grid>

                </Form>

                <Grid.Row>
                    <Grid.Column width={16}>
                        <ContributorsModal isModalOpen={this.props.isModalOpen}
                            searchUserArr={this.props.searchUserArr}
                            selectedOrganisation={this.props.selectedOrganisation}
                            userSearchObject={this.props.userSearchObject}
                            participantsData={this.props.participantsData}
                            user={this.props.user}
                            showResourecePaneFlag={this.props.showResourecePaneFlag}
                            invitedUsersArray={this.props.invitedUsersArray}
                            searchInviteUserArr={this.props.searchInviteUserArr}
                            accountId={this.props.match.params.accountId}
                            workspaceId={this.props.match.params.workspaceId}
                        />
                    </Grid.Column>
                </Grid.Row>
                {this.props.isRoleChangeModalOpen ?
                    <EditContributorRole isRoleChangeModalOpen={this.props.isRoleChangeModalOpen}
                        participantsData={this.props.participantsData}
                        editUserDetails={this.state.editUserDetails}
                        showResourecePaneFlag={this.props.showResourecePaneFlag}
                        user={this.props.user}
                        string="createPlaybook"
                    /> : ''}

            </div >
        )
    }
}
export default withRouter(CreatePack)
